import axios from 'axios';

let token = localStorage.getItem('token');
/*eslint-disable */

let config = {
    timeout: 120000,
    headers: {
        Authorization: token ? `Bearer ${token}` : 'Bearer ',
        Pragma: 'no-cache'
    },
    baseURL: '/backend'
};

try {
    if (process && process.env.NODE_ENV === 'development') {
        config.baseURL = 'http://localhost:7788';
    }
} catch (err) {}

/*eslint-enable */
export default axios.create(config);



// WEBPACK FOOTER //
// ./src/api.js